import { Component, Fragment, h, Prop } from '@stencil/core';
import { BookingDetails, RtrError, StepItem, StepsError } from '../../../../redux/types';
import { Steps } from '../types';

@Component({
  tag: 'rentware-checkout-template',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCheckoutTemplate {
  @Prop() currentStep: StepItem;
  @Prop() visitedSteps: string[];
  @Prop() steps;
  @Prop() areBreadCrumbsOpen: boolean;
  @Prop() isAnimationOpen: boolean;
  @Prop() isWaiting: boolean;
  @Prop() isSavingDataForm: boolean;
  @Prop() bookingDetails: BookingDetails;

  @Prop() onCloseBreadCrumbsClick;
  @Prop() onBreadCrumbsLinkClick;
  @Prop() onGoToStep: (id: string) => void;
  @Prop() onStepClick;
  @Prop() onCloseCheckout;
  @Prop() onNextBtnClick: () => void;
  @Prop() onFormValid;
  @Prop() onComponentLoaded;
  @Prop() buttonNextStepText: string;

  @Prop() refBilling;
  @Prop() billingStepValues: any;

  @Prop() refShipping;

  @Prop() refDataForm;

  @Prop() orderReference: string;

  @Prop() bookingCompleted;
  @Prop() markPaymentAsCompleted;

  @Prop() stepErrors: StepsError[];
  @Prop() errors: RtrError[];
  @Prop() removeError;
  @Prop() handleGoToFirstErrorClick;
  @Prop() onValidateClick: () => void;
  @Prop() setCheckoutWaiting: (value: boolean) => void;
  @Prop() saveDataFormValues;


  onRentwareSubmitBilling = e => {
    e.preventDefault();
  };

  onRentwareSubmitDataForm = e => {
    e.preventDefault();
  };

  componentWillLoad() {
    this.onComponentLoaded(RentwareCheckoutTemplate.name);
  }

  get currentIndex() {
    return this.steps.findIndex(step => step.id === this.currentStep.id);
  }

  get showActionBar(): boolean {
    return this.currentStep.kind !== 'payment';
  }

  render() {
    if (this.bookingCompleted) {
      return (
        <Fragment>
          <div class="CheckoutContainer">
            <rentware-checkout-nav-bar onCloseCheckout={this.onCloseCheckout} />

            <div class="ContentContainer">
              <rentware-checkout-success markPaymentAsCompleted={this.markPaymentAsCompleted} />
            </div>
          </div>

          <div class="CheckoutTemplateModal" onClick={this.onCloseCheckout} />
        </Fragment>
      );
    }

    return (
      <Fragment>
        <div class="CheckoutContainer">
          {this.showActionBar && <rentware-checkout-action-bar buttonNextStepText={this.buttonNextStepText} nextClick={this.onNextBtnClick} isWaiting={this.isWaiting} />}

          <rentware-checkout-nav-bar
            currentStep={this.currentStep}
            currentIndex={this.currentIndex}
            steps={this.steps}
            onStepClick={this.onStepClick}
            onCloseCheckout={this.onCloseCheckout}
            errors={this.stepErrors}
            handleGoToFirstErrorClick={this.handleGoToFirstErrorClick}
            onValidateClick={this.onValidateClick}
            onGoToStep={this.onGoToStep}
            onNextBtnClick={this.onNextBtnClick}
            isWaiting={this.isWaiting}
          />

          {this.currentStep.description && <rentware-step-description />}

          <div class="ContentContainer">
            {this.currentStep.kind === Steps.Custom && !this.currentStep.config?.dataFormId && (
              <rentware-items-list currentStep={this.currentStep} bookingDetails={this.bookingDetails} key={this.currentStep.id} />
            )}

            {this.currentStep.kind === Steps.Custom && this.currentStep.config?.dataFormId && (
              <rentware-custom-data-form-step
                key={this.currentStep.id}
                ref={el => this.refDataForm(el)}
                onRentwareSubmitDataForm={e => this.onRentwareSubmitDataForm(e)}
                onFormValid={this.onFormValid}
                currentStep={this.currentStep}
                errors={this.stepErrors}
                isSavingDataForm={this.isSavingDataForm}
                saveDataFormValues={this.saveDataFormValues}
              />
            )}

            {this.currentStep.kind === Steps.PersonalDetails && (
              <rentware-billing-step
                ref={el => this.refBilling(el)}
                onRentwareSubmitBilling={e => this.onRentwareSubmitBilling(e)}
                billingStepValues={this.billingStepValues}
                onFormValid={this.onFormValid}
                currentStep={this.currentStep}
                errors={this.stepErrors}
              />
            )}

            {this.currentStep.kind === Steps.Shipping && (
              <rentware-shipping-step ref={el => this.refShipping(el)} removeError={this.removeError} currentStep={this.currentStep} errors={this.stepErrors} />
            )}

            {this.currentStep.kind === Steps.Payment && (
              <rtr-step-payment
                currentStep={this.currentStep}
                errors={this.errors}
                orderReference={this.orderReference}
                isWaiting={this.isWaiting}
                setCheckoutWaiting={this.setCheckoutWaiting}
                onActionButton={this.onNextBtnClick}
                removeStepError={this.removeError}
              />
            )}
          </div>

          {this.areBreadCrumbsOpen && (
            <rentware-checkout-breadcrumbs
              steps={this.steps}
              currentStep={this.currentStep}
              currentStepIndex={this.currentIndex}
              visitedSteps={this.visitedSteps}
              numberOfSteps={this.steps.length - 1}
              onCloseBreadCrumbsClick={this.onCloseBreadCrumbsClick}
              onBreadCrumbsLinkClick={this.onBreadCrumbsLinkClick}
              isAnimationOpen={this.isAnimationOpen}
              errors={this.stepErrors}
            />
          )}
        </div>

        <div class="CheckoutTemplateModal" onClick={this.onCloseCheckout} />
      </Fragment>
    );
  }
}
